module.exports = __webpack_public_path__ + "img/Synthetix.73c82235.png";